import React from 'react';

const TempLandingPage = () => {
	return (
		<div>
			<h1>Jenny Ardrey Portfolio</h1>
			<p>Under construction</p>
		</div>
	)
}

export default TempLandingPage